import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './beauty_v2/Header';
import Footer from './beauty_v2/Footer';
import Home from './beauty_v2/Home';
import Soins from './beauty_v2/Soins';
import Team from './beauty_v2/Team';
import Book from './beauty_v2/Book';

export default function BeautyTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F7E6E0]" data-testid="beauty-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`beauty-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'soins' && <Soins setPage={setPage} />}
          {page === 'team' && <Team setPage={setPage} />}
          {page === 'book' && <Book setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
